import { ErrorHandler, Injectable, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NoInternetConnectionModalComponent } from './shared-components/no-internet-connection-modal/no-internet-connection-modal.component';
import { AppInsights } from 'applicationinsights-js';
import { System } from './shared-components/System';
import { timer, Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { LoginService } from './shared-modules/login/login.service';

@AutoUnsubscribe({ includeArrays: true })
@Injectable()
export class ErrorsHandler implements ErrorHandler, OnDestroy {

    public noInternetDialogRef: MatDialogRef<NoInternetConnectionModalComponent>;
    private checkingNetworkConnection = false;
    private continuousChecking = false;
    private subscriptions: Subscription[] = [];

    constructor(private dialog: MatDialog, private loginService: LoginService) {
        this.subscriptions.push(loginService.observableLoginErrorStream$.subscribe(err => {
            this.handleError(err);
        }));
    }

    handleError(error: Error) {
        console.error(error);

        if (!this.noInternetDialogRef && !this.checkingNetworkConnection) {
            // Server or connection error happened
            if (!navigator.onLine) {
                this.showNoInternetModal();
            } else {
                if (!this.noInternetDialogRef) {
                    this.checkingNetworkConnection = true;
                    if (this.canContactServer(4)) {
                    }
                    else {
                        this.showNoInternetModal();
                    }
                    this.checkingNetworkConnection = false;
                }
            }
        }

        // Tracking exception
        if (!AppInsights.disableTelemetry) {
            AppInsights.trackException(error);
        }
    }

    canContactServer(numberOfTriesLeft: number): boolean {
        if (numberOfTriesLeft > 0) {
            const xhr = new XMLHttpRequest();
            let url = System.baseUrl;
            if (window.location.hostname == 'localhost') {
                url = window.location.hostname;
            }

            // Open new request as a HEAD to the root hostname with a random param to bust the cache
            xhr.open('HEAD', url + '?rand=' + Math.floor((1 + Math.random()) * 0x10000), false);

            // Issue request and handle response
            try {
                xhr.send();
                if (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304)) {
                    this.continuousChecking = false;
                    if (this.noInternetDialogRef) {
                        this.noInternetDialogRef.componentInstance.hideSpinner();
                        this.noInternetDialogRef.componentInstance.connectionRestored = true;
                    }
                    return true;  // success
                }
                else {
                    return this.canContactServer(numberOfTriesLeft - 1); // failed - try again - could be transient failure
                }
            } catch (error) {
                return this.canContactServer(numberOfTriesLeft - 1); // failed - try again - could be transient failure
            }
        }
        else {
            return false;
        }
    }

    showNoInternetModal() {
        if (!this.noInternetDialogRef && window.location.pathname.indexOf('login') < 0) {
            this.continuousChecking = true;
            const timerSubscription = timer(5000, 5000).subscribe(x => {
                if (this.continuousChecking) {
                    if (this.canContactServer(3)) {
                        timerSubscription.unsubscribe();
                    }
                }
                else {
                    timerSubscription.unsubscribe();
                }
            });
            this.subscriptions.push(timerSubscription);
            this.noInternetDialogRef = this.dialog.open(NoInternetConnectionModalComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true
            });
            this.noInternetDialogRef.componentInstance.hideSpinner();
            this.noInternetDialogRef.afterClosed().subscribe(data => {
                this.noInternetDialogRef = undefined;
                this.continuousChecking = false;
            });
        }
    }

    ngOnDestroy() { }
}
